var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0493 8.49975L17.9993 7.36975C17.7393 6.21976 17.0893 5.55976 17.0893 5.55976C16.7002 5.16989 16.2381 4.86059 15.7293 4.64956C15.2205 4.43852 14.6751 4.32989 14.1243 4.32989C13.5735 4.32989 13.0281 4.43852 12.5193 4.64956C12.0106 4.86059 11.5484 5.16989 11.1593 5.55976L9.67932 7.03975L3.04932 -0.000244141C2.04932 3.99976 3.04932 7.99975 5.49932 11.2198L0.0493164 16.4998C0.0493164 16.4998 8.93932 18.4998 14.1193 14.4498C16.8793 12.2898 17.4993 11.0298 17.8893 9.69975L21.0493 8.49975ZM15.7593 8.71976C15.3693 9.10975 14.7293 9.10975 14.3393 8.71976C14.2466 8.62724 14.1731 8.51735 14.1229 8.39638C14.0727 8.27541 14.0469 8.14572 14.0469 8.01476C14.0469 7.88379 14.0727 7.7541 14.1229 7.63313C14.1731 7.51216 14.2466 7.40227 14.3393 7.30976C14.7293 6.91976 15.3693 6.91976 15.7593 7.30976C16.1493 7.69976 16.1493 8.32975 15.7593 8.71976Z",
    fill: "#DAEDFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e8d8b4968df0f123a3508f838164f6ec.svg";
export { ForwardRef as ReactComponent };